import { BenefitCards } from '@/components/BenefitCards';
import { BookSkiPass } from '@/components/BookSkiPass';
import { Footer } from '@/components/Footer';
import { FrequentlyAskedQuestions } from '@/components/FrequentlyAskedQuestions';
import { Header } from '@/components/Header';
import styles from './HomePage.module.css';

export const HomePage = () => {
  return (
    <main className={styles.page}>
      <Header />
      <div className={styles.content}>
        <BookSkiPass />
        <BenefitCards />
        <FrequentlyAskedQuestions />
      </div>
      <Footer />
    </main>
  );
};
